import React from 'react'

import FieldView from "../../../fields3/render/view"
import FieldsFactory from "../../../fields3/fields-factory"
import {FieldType} from "../../../fields3/field-type"

export default function FieldColorViewInImport(props) {

    const field3 = FieldsFactory.get({
        fieldId : 'color',
        label   : 'Color',
        type    : FieldType.COLOR
    })

    return (
        <FieldView field={field3} model={{color: props.value}}/>
    )
}